export type TExamV3ReservationSettings = {
  examReservationMode?: number;
  sizeReservationTemplate?: number;
  capacityReservationTemplate?: number;
  requiredInvigilatorNumber?: number;
};

export enum ESeatingMode {
  StudentSpecific = 'student-specific',
  StudentRange = 'student-range',
  ExamRange = 'exam-range',
}

export enum ESeatingMethod {
  clumped = 'clumped',
  spread = 'spread',
}

export enum ELayoutPattern {
  standard = 'standard',
  snake = 'snake',
}

export type ISeatAllocationSettings = {
  seatingMode: {
    mode: ESeatingMode;
    allowOverride: boolean;
  };
  seatingMethod: {
    mode: ESeatingMethod;
    allowOverride: boolean;
  };
  layoutPattern?: {
    mode: ELayoutPattern;
    allowOverride: boolean;
  };
  sorting: {
    allowOverride: boolean;
    sortBy?: number;
    sortByName?: string;
    sort: 'asc' | 'desc';
  };
};
